import React from 'react'
import DownloadIcon from '@material-ui/icons/GetApp'
import { saveAs } from 'file-saver'
import { format } from 'date-fns'

type ChartDownloadButtonProps = {
  getPng(): Promise<string | undefined>
  fileName: string
}

export const ChartDownloadButton = (props: ChartDownloadButtonProps) => {
  const { getPng, fileName } = props

  const handleDownload = React.useCallback(async () => {
    const png = await getPng()

    if (png) {
      saveAs(png, `${fileName}_${format(new Date(), 'ddMMyyyy')}.png`)
    }
  }, [getPng, fileName])

  return (
    <div
      className="flex max-w-max items-center p-1 bg-tertiary rounded-t-md cursor-pointer"
      onClick={handleDownload}
      data-testid={'chart-download-button'}
    >
      <DownloadIcon fontSize="large" />
      <span className="mx-2 font-semibold">(PNG)</span>
    </div>
  )
}
